import config from 'constants/config'
import { ChertoExperiments } from 'constants/experiments'
import { canUseExperimentationOnClient } from '../../client/consent/waitingForConsent'
import { getChertoBucketingId } from 'lib/experiments/chertoBucketingId'
import { getChertoExperimentVariation } from 'selectors/experimentSelectors'

export type LesaEscalationVariation = (typeof ChertoExperiments.lesaAtiRemoval.variations)[number]

const isOverriddenLocally = () => config[`CHERTO_${ChertoExperiments.lesaAtiRemoval.id}`] !== undefined

export type LesaEscalationUnassignedReason = 'no_consent' | 'syncing' | 'logged_out' | 'unit_mismatch' | 'no_variation'

type LesaEscalationAssignment =
  | { variation: LesaEscalationVariation, unassignedReason?: undefined }
  | { variation?: undefined, unassignedReason: LesaEscalationUnassignedReason }

// Unassigned (never control) until the decision is settled for the member logged in now: an account switch
// can leave the previous member's arm in state. A spoofed session uses the spoofed member's arm.
export function selectLesaEscalationAssignment(state: App.State): LesaEscalationAssignment {
  const experiment = ChertoExperiments.lesaAtiRemoval
  const memberId = state.auth.account.memberId

  if (!canUseExperimentationOnClient()) {
    return { unassignedReason: 'no_consent' }
  }
  if (state.optimizely.isPostLoginExperimentSyncing) {
    return { unassignedReason: 'syncing' }
  }
  // A local override has no unit to compare.
  if (!isOverriddenLocally()) {
    if (!memberId) {
      return { unassignedReason: 'logged_out' }
    }
    if (getChertoBucketingId(state.cherto.units, experiment.id) !== memberId) {
      return { unassignedReason: 'unit_mismatch' }
    }
  }

  const variation = getChertoExperimentVariation(state, experiment)
  const known = experiment.variations.find(known => known === variation)
  return known ? { variation: known } : { unassignedReason: 'no_variation' }
}
